import { CollectionPropertyType } from "commons/types/validation";

import { notEmptyValidator } from "commons/utils/validate";

import { LanguageEnum, MetaFields } from "types/api/commons";

export const metaFieldsSchema: CollectionPropertyType = {
    type: "collection",
    of: {
        type: "object",
        properties: {
            meta_title: {
                type: "simple",
                validators: [notEmptyValidator],
            },
            meta_description: {
                type: "simple",
                validators: [],
            },
            meta_keywords: {
                type: "simple",
                validators: [],
            },
        },
    },
};

export function emptyMetaFields(): MetaFields {
    const emptyItem = { meta_title: "", meta_description: "", meta_keywords: "" };

    return {
        [LanguageEnum.it]: { ...emptyItem },
        [LanguageEnum.en]: { ...emptyItem },
    };
}
